_loadMoreSectionsStatus